import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { ENV } from '@di-tokens';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Must match SENTRY_RELEASE used by the `sentry-sourcemaps` upload.
const SENTRY_RELEASE = 'casino-fe@1.0.0';

if (environment.production) {
  enableProdMode();
}

if (environment?.sentryDsn) {
  // Error reporting only: no tracing, profiling or performance metrics.
  Sentry.init({
    release: SENTRY_RELEASE,
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // Session Replay is recorded only for sessions where an error occurs.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

platformBrowserDynamic([{ provide: ENV, useValue: environment }])
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => Sentry.captureException(err));
